import React, {useState} from 'react';
import styled from "styled-components";
import Carousel, {CarouselItem} from "../../../../molecules/swiper/carousel";
import GalleryFullscreen from "../../../../molecules/swiper/gallery_fullscreen_slide";
import SwiperFullscreen from "../../show/slider/fullscreen";

const HayaatGallerySlide = () => {
    const [fullscreen, setFullscreen] = useState({show: false, slideTo: 0});

    const breakpoints = {
        1024: {
            slidesPerView: 3,
        },
        768: {
            slidesPerView: 2.4,
        },
        320: {
            slidesPerView: 1.5,
        }
    };

    const getImages = (type) => {
        let images = [];

        for (let i = 1; i < 9; i++) {
            images.push(`/_img/landings/hayaat/slider/0${i}-${type}.jpg`)
        }

        return images;
    };

    const handleShowFullscreen = (slidTo) => {
        setFullscreen({show: true, slideTo: slidTo});
    };

    return (
        <Container className="container sm-fluid">
            <Carousel breakpoints={breakpoints} navigation_show={true} pagination={false} autoplay={true} delay={3000}>
                {
                    getImages('thumb').map((item, key) =>
                        <CarouselItem key={key}>
                            <Slide key={key} className="w-100 rounded-8 cursor-pointer" onClick={() => handleShowFullscreen(key)}>
                                <img src={item} alt="" className="img-cover rounded-8"/>
                            </Slide>
                        </CarouselItem>
                    )
                }
            </Carousel>

            <GalleryFullscreen
                items={getImages('large')}
                slide_to={fullscreen.slideTo}
                show={fullscreen.show}
                setShow={setFullscreen}
            />
        </Container>
    );
};

export default React.memo(HayaatGallerySlide);

// styles

const Container = styled.div`

    .swiper-button-prev, .swiper-button-next {
        transform: none;
    }
`;

const Slide = styled.div`
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.16);
    
    
`;